import { Callout } from "@octopusdeploy/design-system-components";
import { links } from "@octopusdeploy/portal-routes";
import InternalLink from "~/components/Navigation/InternalLink/InternalLink";
import useLocalStorage from "~/hooks/useLocalStorage";
export function FinaliseCertificateCallout({ spaceId }: {
    spaceId: string;
}) {
    const [calloutDismissed, setCalloutDismissed] = useLocalStorage(`Octopus.Callout.Drawer.Certificate.Dismissed`, false);
    if (calloutDismissed) {
        return null;
    }
    return (<Callout type={"information"} title="Finalise certificate" hideTitle={false} canClose={true} onClose={() => setCalloutDismissed(true)}>
            <div>
                After you create this certificate, you can find it in{" "}
                <InternalLink to={links.certificatesPage.generateUrl({ spaceId })} openInSelf={false}>
                    Certificates
                </InternalLink>
            </div>
        </Callout>);
}
